import { useCallback } from 'react';

import PropTypes from 'prop-types';

import FormHelperText from '@zenbusiness/zui/FormHelperText';
import FormLabel from '@zenbusiness/zui/FormLabel';
import Radio from '@zenbusiness/zui/Radio';

import { StyledFormControl, StyledOption, StyledRadioGroup } from './OptionGroup.style';

const OptionGroup = ({
  label,
  options,
  value,
  onChange,
  error,
  helperText,
  disabled = false,
  name = 'option-group',
  sx
}) => {
  const handleChange = useCallback(
    (event) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <StyledFormControl data-testid="option-group-form-control" error={error} sx={sx}>
      {label && <FormLabel>{label}</FormLabel>}
      <StyledRadioGroup name={name} value={value} onChange={handleChange}>
        {options.map((option) => (
          <StyledOption
            key={option.value}
            control={<Radio />}
            data-testid={`option-group-option-${option.value}`}
            disabled={disabled}
            label={option.label}
            value={option.value}
          />
        ))}
      </StyledRadioGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </StyledFormControl>
  );
};

OptionGroup.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  sx: PropTypes.object
};

export default OptionGroup;
